export default __webpack_public_path__ + "static/media/obsidian-full.e2b69449.webp";